import { render, staticRenderFns } from "./kabala-fileicon.vue?vue&type=template&id=eeb60494&scoped=true&"
import script from "./kabala-fileicon.vue?vue&type=script&lang=js&"
export * from "./kabala-fileicon.vue?vue&type=script&lang=js&"
import style0 from "./kabala-fileicon.vue?vue&type=style&index=0&id=eeb60494&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeb60494",
  null
  
)

export default component.exports